import React from 'react'
import NewsPage from '../components/News/news-page'
import {getLocalization} from '../localization'


class NewsPageEn extends React.Component {
  render() {
    const { globalLocalization, news } = this.props.data
    const localization = getLocalization(globalLocalization, 'en-US')

    const filteredNews = news.edges.filter(edge => {
      const node = edge.node
      return node.heading && node.body && node.body.body
    })

    return (
      <NewsPage content={ filteredNews } localization={ localization } lang='en'/>
    )
  }
}

export default NewsPageEn

export const query = graphql`
query NewsQueryEn {
  globalLocalization: allContentfulLocalizationString(filter: {key: {regex: "/^global/" }}) {
    edges {
      node { 
        key
        text
        node_locale
      }
    }
  }

  news: allContentfulNewsArticle(filter: {node_locale: {eq: "en-US"}}, sort: {order: DESC, fields: [createdAt]}) {
    edges {
      node {
        id
        createdAt(formatString: "MMM D, YYYY")
        heading
        body {
          body
        }
        backgroundColor
        featureImage {
          title
          sizes(maxWidth: 2560) {
            ...GatsbyContentfulSizes_withWebp
          }
        }
      }
    }
  }
}
`


// WEBPACK FOOTER //
// ./src/pages/news.en.js